import { execute, command } from 'lib/cqc'
import { Raven } from 'init/raven'
import Backbone from 'init/backbone'
import { CQC_COMMANDS_TYPES_TO_EVENTS, CQC_COMMAND_EVENT } from 'es6/constants'

let executeChannel,
  commandChannel

/**
 * Создает обработчик команд
 * @param {Array} commands - Массив команд
 * @param {string} context - Контекст
 */
export const createExecuteChannel = (commands, context) => {
  if (executeChannel === undefined) {
    executeChannel = execute(commands, context)
  }
}

/**
 * Подписка на команду/команды cqc
 * @param {string|Array} commands - команда или массив команд
 * @param {Function} callback - функция-коллбэк
 */
export const subscribeToCommands = (commands, callback = _defaultCqcCallback) => {
  const executeFunction = async promiseFunction => {
    if (typeof promiseFunction === 'function') {
      try {
        const resolveData = await promiseFunction()
        callback(resolveData)
      } catch (error) {
        Raven.captureException(error)
      }
    }
  }
  executeChannel(commands)(executeFunction)
}

/**
 * Дефолтный коллбэк при получении cqc команды
 * @param {Object} command - команда
 * @private
 */
const _defaultCqcCallback = command => {
  Backbone.trigger(CQC_COMMANDS_TYPES_TO_EVENTS[command.type], command)
}

/**
 * Определяет канал для отправки команд в cqc
 * @param {Array}   commands      Команды
 * @param {string}  context       Контекст отправки команд
 * @param {boolean} isBackboneApp Признак инициализации из backbone приложение
 */
export const createCommandChannel = (commands, context, isBackboneApp = false) => {
  if (commandChannel === undefined && commands && context) {
    commandChannel = command(commands, context)
  }
  if (isBackboneApp && Backbone !== undefined && typeof Backbone.on === 'function') {
    Backbone.on(CQC_COMMAND_EVENT, sendCommand)
  }
}

/**
 * Отправка команд
 * @param {Object} commandData      Данные команды
 * @param {string} commandData.type Тип команды
 */
export const sendCommand = commandData => {
  if (typeof commandChannel === 'function' && commandData.type) {
    commandChannel(commandData)
  }
}
